import styled from "styled-components"

export const IconPage = () => {
  return(
    <StyleWrap>
      IconPage
    </StyleWrap>  
  )
}

const StyleWrap = styled.div`

`;